export default __webpack_public_path__ + "90ce612697bbf150ddda96339555d061.svg";